import enLangContent from "./en.json";
import jpLangContent from "./jp.json";

export const Language = {
    EN: "EN",
    JP: "JP",
};

const languageMap = {
    [Language.EN]: enLangContent,
    [Language.JP]: jpLangContent,
};

export function getLocalizedText(lang, key) {
    if (!(lang in languageMap && key in languageMap[lang])) {
        return key;
    }
    return languageMap[lang][key];
}

export function getLocalizer(lang) {
    return getLocalizedText.bind(null, lang);
}
